export default "<p *ngIf=\"message\" [ngClass]=\"message.cssClass\">{{message.text.data.message}}</p>"